import { createContext } from "react";
import type { DokumentTyp } from "@/lib/dokumente";

export type DocumentCreateCreatedHandler = (docId: number) => void;

export interface DocumentCreateOpenOptions {
  auftragId?: number | null;
  typ?: DokumentTyp;
  quellDokumentId?: number | null;
  onCreated?: DocumentCreateCreatedHandler;
  /** Nur für Deep-Link-Route: wohin nach Schließen ohne Anlage navigiert wird. */
  returnTo?: string;
}

export interface DocumentCreateContextValue {
  open: (options?: DocumentCreateOpenOptions) => void;
  close: () => void;
  isOpen: boolean;
}

export const DocumentCreateContext = createContext<DocumentCreateContextValue | null>(null);
